import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { Navigation } from 'app/core/navigation/navigation.types';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { FormGroup, UntypedFormBuilder } from '@angular/forms';
import { AuthService } from 'app/core/auth/auth.service';
import { User } from 'app/core/user/user.types';
import { EncryptdecryptService } from 'app/shared/services/encryptdecrypt.service';
import { UserService } from 'app/modules/user/user.service';

@Component({
    selector: 'compactlight-layout',
    templateUrl: './compactlight.component.html',
    encapsulation: ViewEncapsulation.None
})
export class CompactLightLayoutComponent implements OnInit, OnDestroy {

    user: User;
    encryptstring: string = "";
    isScreenSmall: boolean;
    navigation: Navigation;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    roleFrom: FormGroup = new FormGroup({
    })

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private _userService: UserService,
        private _formBuilder: UntypedFormBuilder,
        private _authService: AuthService,
        private EncrDecr: EncryptdecryptService

    ) {
        this.user = JSON.parse(_authService.accessUser);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {

        debugger;

        this.roleFrom = this._formBuilder.group({
            UserID: [this.user.id]
        });


        // Subscribe to navigation data
        // menubind
        // this._navigationService.navigation$
        //     .pipe(takeUntil(this._unsubscribeAll))
        //     .subscribe((navigation: Navigation) => {
        //         //console.log('navigation --> ', navigation);

        //         this.navigation = navigation;
        //     });



        this._userService.GetRoleDataById(this.roleFrom.value).subscribe(
            (res: any) => {
                debugger;

                console.log("menu bind-->", res);
                this.navigation = res;
                console.log("this.navigation ->", res);


            },
            (error) => {

                console.log(error);
            }
        );





        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {
                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
       
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }
    partnerdetail(id: any): void {
        //debugger;
        this.EncrDecr.getEncryptid(id).subscribe(
            (res: any) => {
                //debugger;
                this.encryptstring = res.encryptedText;
                if (this.encryptstring != null && this.encryptstring != '') {
                    this._router.navigate(['/partner/partnerdetail', this.encryptstring]);
                }
            })

    }
}
